import React from 'react';

import LocalTime from '../messages/LocalTime';
import WidgetIcon from '../shared/WidgetIcon';

const WidgetAnnouncementActivityContent = ({ activity, actor }) => {
  const sourceWidget = activity.data?.source_widget || null;
  const actorName = actor?.full_name || 'Someone';
  const verb = activity.data?.verb || 'updated';
  const subjectLabel = activity.data?.subject_label || sourceWidget?.title || 'a widget';

  return (
    <div className="flex min-w-0 items-center gap-2">
      <span className="inline-flex size-8 shrink-0">
        <WidgetIcon widget={sourceWidget} className="size-8" />
      </span>
      <span className="min-w-0 truncate text-cursed">
        <span className="font-semibold text-black dark:text-neutral-100">{actorName}</span>{' '}
        <span className="text-gray-500 dark:text-neutral-400">{verb}</span>{' '}
        <span className="font-medium text-gray-700 dark:text-neutral-200">{subjectLabel}</span>
      </span>
      <span className="ml-auto shrink-0 text-2xs text-gray-400 select-none dark:text-neutral-500">
        <LocalTime timestamp={activity.timestamp} type="time-ago" />
      </span>
    </div>
  );
};

export default WidgetAnnouncementActivityContent;
